var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import EventEmitter from 'events';
import { UserWebStorageInstance } from '../user-web-storage';
import { ApplicationVersion } from './ApplicationVersion';
import { ApplicationInfo } from './ApplicationInfo';
export class ApplicationVersionController {
    constructor() {
        this._versionUpdateTime = 10 * 60 * 1000; // 10 minutes
        this._eventEmitter = new EventEmitter();
    }
    updateBuildVersion() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const versionString = yield UserWebStorageInstance.getVersion();
            if (!isValidString(versionString)) {
                return;
            }
            const appVersion = ApplicationVersion.createApplicationVersionByJson(versionString);
            if (!((_a = ApplicationInfo.BuildVersionData) === null || _a === void 0 ? void 0 : _a.isEqualTo(appVersion))) {
                this.notifyBuildVersionUpdated(appVersion);
            }
        });
    }
    subscribeOnBuildVersionUpdate(listener) {
        this._eventEmitter.on('buildVersionUpdated', listener);
    }
    unsubscribeOnBuildVersionUpdate(listener) {
        this._eventEmitter.off('buildVersionUpdated', listener);
    }
    startVersionUpdates() {
        if (!isNullOrUndefined(this._versionUpdateTimer)) {
            return;
        }
        this._versionUpdateTimer = setInterval(() => {
            this.updateBuildVersion();
        }, this._versionUpdateTime);
    }
    stopVersionUpdates() {
        if (isNullOrUndefined(this._versionUpdateTimer)) {
            return;
        }
        clearInterval(this._versionUpdateTimer);
        this._versionUpdateTimer = null;
    }
    notifyBuildVersionUpdated(appVersion) {
        this._eventEmitter.emit('buildVersionUpdated', appVersion);
    }
}
export const applicationVersionController = new ApplicationVersionController();
